import { v4 as uuidv4 } from 'uuid'
import utils from '~/components/tools/utils'
import {
  accessLogRequestConfig,
  buildAccessLogPayload,
  getAccessLogsUrl
} from '~/helpers/access-logs'

export const getters = {
  isUserAdmin (state) {
    return (
      state.auth?.user?.['http://cm24.de/roles']?.includes('admin') ?? false
    )
  },
  isNlDomain (state) {
    return state?.general.host?.includes('.nl')
  }
}

function getOrSetSessionCookie ({
  $cookies,
  req
}) {
  const sessionId = $cookies.get('X-Session-Id')
  if (!sessionId) {
    const uuid = uuidv4()

    const domain = req.headers.host.replace('www', '')
      .replace('.staging', '')

    $cookies.set('X-Session-Id', uuid, {
      path: '/',
      domain,
      sameSite: 'Lax',
      secure: true
    })
  }
}

export const actions = {
  async nuxtServerInit ({ dispatch }, context) {
    getOrSetSessionCookie(context)

    try {
      await dispatch('getCm24CookieAndLog', context)
    } catch (e) {
      console.error('could not run nuxtServerInit', e)
    }

    try {
      await dispatch('messages/getNotifications', {})
    } catch (e) {
      console.warn('could not run nuxtServerInit', e)
    }

    await dispatch('general/setHost', context.req.headers.host)
  },

  async initCm24Uuid ({ commit }, {
    query,
    $axios,
    $cookies,
    domain,
    req
  }) {
    // console.log('initCm24Uuid', query, domain)

    let uuid
    try {
      if (query.cm24) {
        // console.log('found cm24 in query', query.cm24)
        const entityId = utils.parseEntityId(req.url)
        if (entityId) {
          const url = `/public/product/can-set-cm24-uuid/${entityId}/${query.cm24}`
          const { data: canSet } = await $axios.get(url)
          console.log(canSet)
          if (canSet) {
            console.log('can set cm24-uuid from query', query.cm24)
            uuid = query.cm24
          } else {
            console.warn('Cannot set cm24-uuid cookie ' + query.cm24 + '  for entityId ' + entityId)
          }
        }
      }
    } catch (e) {
      console.error('could not verify if we can set cm24-uuid from query', e)
    }

    if (!uuid) {
      // console.log('no cm24 in query or cannot set, fetching from backend')
      const { data } = await $axios.post(
        '/public/customer/cookie/get',
        { params: query },
        { withCredentials: true }
      )
      uuid = data.uuid
    }

    $cookies.set('cm24-uuid', uuid, {
      path: '/',
      domain,
      maxAge: 60 * 60 * 24 * 365,
      sameSite: 'Lax',
      secure: true
    })
    return uuid
  },

  async getCm24CookieAndLog ({
    dispatch,
    commit
  }, {
    $axios,
    query,
    $cookies,
    req,
    $config,
    route
  }) {
    // console.log('getCm24CookieAndLog')
    try {
      const domain = req.headers.host.replace('www', '')
        .replace('.staging', '')
      const uuid = await dispatch('initCm24Uuid', {
        query,
        $axios,
        $cookies,
        domain,
        req
      })

      const referer = req.headers?.referrer || req.headers?.referer

      const accessLogsUrl = getAccessLogsUrl($config.apiBaseURL)
      const payload = buildAccessLogPayload({
        route,
        query,
        $cookies,
        cm24Uuid: uuid,
        referer
      })

      $axios.post(accessLogsUrl, payload, accessLogRequestConfig()).catch(() => {
      })
    } catch (e) {
      console.log('could not get cm24-uuid or post to access-logs', e)
    }
  }

}
